import { push } from "connected-react-router";
import { put, takeLeading } from "redux-saga/effects";
import handleNetworkError from "sagas/helpers/handleNetworkError";
import { post } from "sagas/helpers/network";

function* execute(action: sage.actions.team.IRemoveSelfFromTeam) {
    try {
        yield post("/remove-self-from-team", {
            team_id: action.teamId,
        });
    } catch (e) {
        yield handleNetworkError(e);
        return;
    }
    yield put(push("/home/teams"));
    yield put({
        type: "com.sage.actions.team.IFetchInvitedTeams",
    } as sage.actions.team.IFetchInvitedTeams);
    yield put({
        type: "com.sage.actions.team.IFetchMemberTeams",
    } as sage.actions.team.IFetchMemberTeams);
}

export default function* saga(): Generator {
    yield takeLeading("com.sage.actions.team.IRemoveSelfFromTeam", execute);
}
